import { FLEET } from '../data/fleet'
import DataPlate from './DataPlate'

export default function Fleet() {
  return (
    <section className="section" id="fleet">
      <div className="wrap">
        <div className="section__head">
          <span className="eyebrow">The fleet</span>
          <h2>Three units. Bought new, kept clean.</h2>
          <p>
            Small fleet on purpose. Every trailer gets inspected between
            rentals, so you are not the one finding a soft tire at 7&nbsp;a.m.
          </p>
        </div>

        <div className="fleet">
          {FLEET.map((trailer) => (
            <DataPlate key={trailer.id} trailer={trailer} />
          ))}
        </div>
      </div>
    </section>
  )
}
